import { Suspense } from "react";
import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";
import useProgressIndicatorOverlay from "./useProgressIndicatorOverlay";
import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";

const ProgressIndicatorWrapper = ({
  whenInProgressMessage,
  children,
  isInProgress,
  onRemovedCallback,
  visibleOverlayClassName,
  invisibleOverlayClassName,
  ...rest
}) => {
  const { onAnimationEnd, isInDOM, isVisible } = useProgressIndicatorOverlay({
    isInProgress,
    onRemovedCallback
  });

  const progressIndicatorWithOverlay = (
    <div
      className={classnames(styles.progressIndicatorOverlay, {
        [styles.visible]: isVisible,
        [invisibleOverlayClassName]: invisibleOverlayClassName && !isVisible,
        [visibleOverlayClassName]: visibleOverlayClassName && isVisible
      })}
      onAnimationEnd={onAnimationEnd}
      aria-live="polite"
      role="status"
    >
      <div className={styles.screenReaderOnly}>{whenInProgressMessage}</div>
      <ProgressIndicator {...rest} />
    </div>
  );

  return (
    <div className={styles.progressIndicatorWrapper}>
      <Suspense fallback={progressIndicatorWithOverlay}>
        {children}
        {isInDOM ? progressIndicatorWithOverlay : null}
      </Suspense>
    </div>
  );
};

ProgressIndicatorWrapper.propTypes = {
  whenInProgressMessage: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  isInProgress: PropTypes.bool.isRequired,
  onRemovedCallback: PropTypes.func,
  visibleOverlayClassName: PropTypes.string,
  invisibleOverlayClassName: PropTypes.string
};

export default ProgressIndicatorWrapper;
